import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link } from 'components/ui';
import ProductList from 'components/Content/ProductList';
import contentConstants from 'constants/content';
import localeUtils from 'utils/LanguageLocale';
import SaveForLaterListEN from 'components/SaveForLater/SaveForLaterList/locales/SaveForLaterList_en_US';
import SaveForLaterListFR from 'components/SaveForLater/SaveForLaterList/locales/SaveForLaterList_fr_CA';
import Empty from 'constants/empty';
import { SAVE_FOR_LATER_LIST_TYPE } from 'constants/saveForLater';

const { PRODUCT_LIST_GROUPING } = contentConstants;
const { getLocalisedDataFromResource } = localeUtils;

function SaveForLaterList(props) {
    const {
        saveForLaterCarouselData, saveForLaterLoading, removeSaveForLaterItem, getSaveForLaterLists, userId
    } = props;

    const getText = getLocalisedDataFromResource(SaveForLaterListEN, SaveForLaterListFR);

    const hasData = saveForLaterCarouselData?.skuList?.length > 0;

    if (!saveForLaterLoading && !hasData) {
        return null;
    }

    const removeSavedForLater = ({ sku }) => {
        if (!sku || !userId || !saveForLaterCarouselData?.listId) {
            return Promise.resolve();
        }

        const skuId = sku.skuId || sku.sku?.skuId;
        const productId = sku.productId || sku.sku?.productId;

        if (!skuId || !productId) {
            return Promise.resolve();
        }

        return removeSaveForLaterItem(userId, {
            skuId,
            productId,
            shoppingListId: saveForLaterCarouselData.listId,
            shoppingListType: SAVE_FOR_LATER_LIST_TYPE
        })
            .then(() => getSaveForLaterLists?.(userId))
            .catch(error => Sephora.logger.error('Error removing Save For Later item:', error));
    };

    const handleRemoveClick = sku => event => {
        event.preventDefault();
        event.stopPropagation();
        removeSavedForLater({ sku });
    };

    const renderRemoveLink = ({ sku }) => {
        return (
            <Link
                onClick={handleRemoveClick(sku)}
                color='blue'
            >
                {getText('remove')}
            </Link>
        );
    };

    return (
        <ProductList
            key='saved-for-later-carousel'
            skuList={saveForLaterCarouselData?.skuList || Empty.Array}
            title={`${getText('savedForLaterTitle')} (${saveForLaterCarouselData?.totalItems || 0})`}
            grouping={[PRODUCT_LIST_GROUPING.SHOW_PRICE, PRODUCT_LIST_GROUPING.SHOW_MARKETING_FLAGS, PRODUCT_LIST_GROUPING.SHOW_ADD_BUTTON]}
            podId={'saved-for-later'}
            totalResults={saveForLaterCarouselData?.skuList?.length || 0}
            isCarousel={true}
            variant={'Horizontal Carousel'}
            renderRightAction={saveForLaterLoading ? undefined : renderRemoveLink}
            actionLabel={getText('viewAll')}
            action={{ href: '/shopping-list' }}
            showSkeleton={saveForLaterLoading}
            addButtonText={getText('moveToBasket')}
        />
    );
}

SaveForLaterList.propTypes = {
    saveForLaterCarouselData: PropTypes.shape({
        skuList: PropTypes.array,
        totalItems: PropTypes.number,
        listId: PropTypes.string
    }),
    saveForLaterLoading: PropTypes.bool,
    removeSaveForLaterItem: PropTypes.func.isRequired,
    getSaveForLaterLists: PropTypes.func,
    userId: PropTypes.string
};

export default wrapFunctionalComponent(SaveForLaterList, 'SaveForLaterList');
